
<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  data() {
    let self = this;
    return {
      gradient: null,
      gradient2: null,
      classifierNames: ["hate", "emotion_ensemble"] //, "sentiment"
    };
  },
  props: {
    commentsData: {
      default: function() {
        return {};
      },
      type: Object
    }
  },
  computed: {
    chartData() {
      let data = {};

      let time = 0;
      let lastQuotient = 0;
      let bucket = {};
      let self = this;
      let bucketDuration = 50;

      for (const classifierName of self.classifierNames) {
        data[classifierName] = [];
      }
      function initBuckets() {
        for (const classifierName of self.classifierNames) {
          bucket[classifierName] = [];
        }
      }
      initBuckets();
      let average = array => array.reduce((a, b) => a + b, 0) / array.length;
      let sum = array => array.reduce((a, b) => a + b, 0);
      let maximum = array => Math.max(...array);
      let maxVal = 0;

      for (let comment of this.commentsData.comments) {
        let quotient = Math.floor(
          comment["content_offset_seconds"] / bucketDuration
        );
        for (const classifierName of self.classifierNames) {
          if (quotient === lastQuotient) {
            let score = comment["classification"][classifierName];
            bucket[classifierName].push(score);
          } else {
            let avScore =
              Math.round(100 * average(bucket[classifierName])) || 0;
            data[classifierName].push({
              x: quotient * bucketDuration - bucketDuration / 2,
              y: avScore
            });
            maxVal = Math.max(avScore, maxVal);
            bucket[classifierName] = [];
          }
        }
        lastQuotient = quotient;
      }

      let chartData = {
        datasets: [
          {
            label: "Hate",
            // backgroundColor: "#FC2525",
            data: data["hate"], // [40, 39, 10, 40, 39, 80, 40]
            borderColor: "#FC2525",
            pointBackgroundColor: "#FC2525",
            borderWidth: 1,
            pointBorderColor: "white",
            backgroundColor: this.gradient,
            pointRadius: 5
          },
          // {
          //   label: "Negativity",
          //   backgroundColor: "orange",
          //   data: data["Negativity"] // [40, 39, 10, 40, 39, 80, 40]
          // },
          {
            label: "Anger",
            // backgroundColor: "#05CBE1",
            borderColor: "#05CBE1",
            pointBackgroundColor: "#05CBE1",
            pointBorderColor: "white",
            borderWidth: 1,
            backgroundColor: this.gradient2,
            data: data["emotion_ensemble"], //[60, 55, 32, 10, 2, 12, 53]
            pointRadius: 5
          }
        ],
        options: {
          responsive: true,

          maintainAspectRatio: false,
          legend: {
            labels: {
              fontColor: "white"
            },
            position: "bottom"
          },
          onClick: function(evt, item) {
            self.clickOnChart(evt, item);
          },
          scales: {
            xAxes: [
              {
                type: "linear",
                ticks: {
                  fontColor: "white",
                  display: false
                },
                position: "top"
              }
            ],
            yAxes: [
              {
                ticks: {
                  fontColor: "white",
                  min: 0,
                  max: maxVal,
                  callback: function(value) {
                    return value + "%";
                  }
                }
              }
            ]
          }
        }
      };
      return chartData;
    }
  },
  methods: {
    clickOnChart(evt, array) {
      if (array.length != 0) {
        var position = array[0]._index;
        let timestamp = this.chartData.datasets[0].data[position].x;
        this.$emit("click", timestamp);
      } else {
        console.log("You selected the background!");
      }
    }
  },
  mounted() {
    this.gradient = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(0, 0, 0, 450);
    this.gradient2 = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(0, 0, 0, 450);

    this.gradient.addColorStop(0, "rgba(255, 0,0, 0.5)");
    this.gradient.addColorStop(0.5, "rgba(255, 0, 0, 0.25)");
    this.gradient.addColorStop(1, "rgba(255, 0, 0, 0)");

    this.gradient2.addColorStop(0, "rgba(0, 231, 255, 0.9)");
    this.gradient2.addColorStop(0.5, "rgba(0, 231, 255, 0.25)");
    this.gradient2.addColorStop(1, "rgba(0, 231, 255, 0)");

    this.renderChart(this.chartData, this.chartData.options);
  }
};
</script>

<style scoped>
canvas {
  /* max-width: 400px !important; */
}

.Chart {
  background: #182952;
  border-radius: 15px;
  box-shadow: 0px 2px 15px rgba(25, 25, 25, 0.27);
  margin: 25px 0;
}

.Chart h2 {
  margin-top: 0;
  padding: 15px 0;
  color: rgba(255, 0, 0, 0.5);
  border-bottom: 1px solid #323d54;
}

#line-chart {
  background-color: #182952;
  border-radius: 0;
  /* box-shadow: 0px 2px 15px rgba(25, 25, 25, 0.27); */
  box-shadow: 0px 0px 0px #182952;
  margin: 25px 0;
}
</style>
